<app-card-base [title]="title" [hasSubmit]="false" [hasFooter]="true">
  <ng-container header-right *ngTemplateOutlet="headerRight"></ng-container>
  <ng-container main *ngTemplateOutlet="contentMain"></ng-container>
</app-card-base>

<ng-template #contentMain>
  @if(equipment){
  <div class="content">
    <div class="details">
      <div *ngIf="equipment.installationDate"><span class="title">Date des travaux</span><span
          class="content">{{equipment.installationDate
          | dateFormat}}</span>
      </div>

      @if (type !== PropertyBookletEquipmentType.network && type !== PropertyBookletEquipmentType.heatingMaintenance) {
      <div *ngIf="equipment.energyClassification">
        <span class="title">Classification</span>
        <span class="content">{{'enum.EnergyClassification.' + equipment.energyClassification | translate}}</span>
      </div>
      }

      @if (type !== PropertyBookletEquipmentType.heatingMaintenance) {
      <div class="detail-doc" [class.is-sent]="equipment.installationDetails">
        <span>Fiche produit</span>
        <mat-icon class="detail-doc-icon"
          [matTooltip]="equipment.installationDetails ? 'Document enregistré' : 'Document absent'">
          {{equipment.installationDetails ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>
      }

      @if (type !== PropertyBookletEquipmentType.network && type !== PropertyBookletEquipmentType.heatingMaintenance) {
      <div class="detail-doc" [class.is-sent]="equipment.productSheet">
        <span>Détails</span>
        <mat-icon class="detail-doc-icon"
          [matTooltip]="equipment.productSheet ? 'Document enregistré' : 'Document absent'">
          {{equipment.productSheet ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>

      <div class="detail-doc" [class.is-sent]="equipment.operationManual">
        <span>Manuel</span>
        <mat-icon class="detail-doc-icon"
          [matTooltip]="equipment.operationManual ? 'Document enregistré' : 'Document absent'">
          {{equipment.operationManual ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>
      }

      <!-- network -->
      @if (type === PropertyBookletEquipmentType.network) {
      <div *ngIf="$any(equipment).subStation">
        <span class="title">Classification</span>
        <span class="content">{{ $any(equipment).subStation }}</span>
      </div>
      }

      <!-- maintenance -->
      @if (type === PropertyBookletEquipmentType.heatingMaintenance) {
      <div *ngIf="$any(equipment).maintenanceDate">
        <span class="title">Date de maintenance</span>
        <span class="content">{{$any(equipment).maintenanceDate | dateFormat}}</span>
      </div>
      <div *ngIf="$any(equipment).maintenanceType">
        <span class="title">Type de maintenance</span>
        <span class="content">{{'enum.MaintenanceTypeList.' + $any(equipment).maintenanceType | translate}}</span>
      </div>
      <div class="detail-doc" [class.is-sent]="$any(equipment).maintenanceCertificate">
        <span>Fiche produit</span>
        <mat-icon class="detail-doc-icon"
          [matTooltip]="$any(equipment).maintenanceCertificate ? 'Document enregistré' : 'Document absent'">
          {{$any(equipment).maintenanceCertificate ? 'task_alt' : 'radio_button_unchecked'}}
        </mat-icon>
      </div>
      }
    </div>
  </div>
  } @else {
  <div class="summary">{{summary}}</div>
  }
</ng-template>

<ng-template #headerRight>
  <button mat-flat-button color="primary" class="card-header-actions" (click)="edit()">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>
